import React, { useState, useEffect } from "react";
import { ToAccountOpenCard } from "./ToAccoundOpenCard";
import { FaWallet } from "react-icons/fa";
import { CommonButton } from "../ui/CommonButton";
import { getLocalStorageItem } from "../../Utils/Helper";
import { useDispatch } from "react-redux";
import { createLiveAccount } from "../../Redux/Action";
import { signup } from "../../Redux/Action/auth/signupAction";
import { PasswordInput } from "../ui/password-input";
import { Text } from "@chakra-ui/react";
import {REG_PARAMS} from "../../Utils/Constants"
export const ToOpenAccount = ({ onSelectAccountType, setRefresh, selectedAccountType, whitelabelData }) => {
    const [openModal, setOpenModal] = useState(null); // "live_account" | "partner_account" | null

    const dispatch = useDispatch();
    const userData = getLocalStorageItem("userData");

    // --- Live Account Form state ---
    const [liveAccountFormData, setLiveAccountFormData] = useState({
        Fname: '',
        Lname: '',
        mobile: '',
        email: '',
        Password: '',
        cpassword: '',
        actype: "LIVE",
        utype: "CLIENT",
        curr: "USD",
        countryCode: "+971",
        ref: ''
    });
    const [liveAccountFormErrors, setLiveAccountFormErrors] = useState({});

    // --- Partner Account Form state ---
    const [partnerFormData, setPartnerFormData] = useState({
        fname: '',
        lname: '',
        email: '',
        mobile: '',
        password: '',
        cpassword: '',
        promo: '',
        referralBy: userData?.referralCode || '',
        role: 7,
        countryCode: "+971",
        userCreatedByIB: true,
        actype: "LIVE",
        utype: "CLIENT",
        curr: "USD"
    });
    const [partnerFormErrors, setPartnerFormErrors] = useState({});

    useEffect(() => {
        if (userData) {
            const fullName = userData.name || "";
            const nameParts = fullName.trim().split(" ");
            const fname = nameParts[0] || "";
            const lname = nameParts.slice(1).join(" ") || "";

            setLiveAccountFormData(prev => {
                // Only update if values differ to avoid infinite loops
                if (
                    prev.Fname !== fname ||
                    prev.Lname !== lname ||
                    prev.mobile !== userData.mobile ||
                    prev.email !== userData.email
                ) {
                    return {
                        ...prev,
                        Fname: fname,
                        Lname: lname,
                        mobile: userData.mobile || "",
                        email: userData.email || "",
                        Password: "",
                        cpassword: "",
                    };
                }
                return prev; // no change, no setState
            });
        }
        // Add whitelabelID to partnerFormData if whitelabelData is not null

    }, [userData]);


    // --- Handlers ---

    // Called on card click to select account type visually
    const handleSelectAccountType = (type) => {
        onSelectAccountType(type);
    };

    // Called on button click to open modal
    const handleOpenModal = (type) => {
        setOpenModal(type);
    };

    // Close modal, reset errors and forms
    const handleCloseModal = () => {
        setOpenModal(null);
        setLiveAccountFormErrors({});
        setPartnerFormErrors({});
        resetForms();
    };

    const resetForms = () => {
        setLiveAccountFormData(prev => ({
            ...prev,
            Password: '',
            cpassword: ''
        }));
        setPartnerFormData(prev => ({
            ...prev,
            fname: '',
            lname: '',
            email: '',
            mobile: '',
            password: '',
            cpassword: '',
            promo: '',
        }));
    };

    // Live account form change
    const handleLiveAccountChange = (e) => {
        console.log("trigerring")
        const { name, value } = e.target;
        setLiveAccountFormData(prev => ({ ...prev, [name]: value }));
        setLiveAccountFormErrors(prev => ({ ...prev, [name]: "" }));
    };

    // Partner account form change
    const handlePartnerFormChange = (e) => {
        const { name, value } = e.target;
        setPartnerFormData(prev => ({ ...prev, [name]: value }));
        setPartnerFormErrors(prev => ({ ...prev, [name]: "" }));
    };

    // Validations

    const validateLiveAccountForm = () => {
        const errors = {};
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#_!])[A-Za-z\d@#_!]{8,}$/;

        if (!liveAccountFormData.Password) errors.Password = "Password is required.";
        else if (!passwordRegex.test(liveAccountFormData.Password))
            errors.Password = "Min 8 chars with uppercase, lowercase, number & special char (@#_!).";

        if (!liveAccountFormData.cpassword) errors.cpassword = "Confirm password is required.";
        else if (liveAccountFormData.Password !== liveAccountFormData.cpassword)
            errors.cpassword = "Passwords do not match.";

        return errors;
    };

    const validatePartnerForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#_!])[A-Za-z\d@#_!]{8,}$/;
        const mobileRegex = /^[0-9]{8,15}$/;

        if (!partnerFormData.fname) errors.fname = "First name is required.";
        if (!partnerFormData.lname) errors.lname = "Last name is required.";
        if (!partnerFormData.email || !emailRegex.test(partnerFormData.email)) errors.email = "Enter a valid email.";
        if (!partnerFormData.password) errors.password = "Password is required.";
        else if (!passwordRegex.test(partnerFormData.password)) {
            errors.password = "Min 8 chars with uppercase, lowercase, number & special char (@#_!).";
        }
        if (!partnerFormData.cpassword) errors.cpassword = "Confirm password is required.";
        else if (partnerFormData.password !== partnerFormData.cpassword) errors.cpassword = "Passwords do not match.";
        if (!partnerFormData.mobile || !mobileRegex.test(partnerFormData.mobile)) {
            errors.mobile = "Enter a valid mobile number.";
        }
        return errors;
    };

    // Submit handlers

    const handleSubmitLiveAccount = (e) => {
        e.preventDefault();
        const errors = validateLiveAccountForm();
        if (Object.keys(errors).length > 0) {
            setLiveAccountFormErrors(errors);
            return;
        }
        setLiveAccountFormErrors({});
        liveAccountFormData.paramsType = REG_PARAMS
        dispatch(
            createLiveAccount({
                payload: liveAccountFormData,
                callback: (data) => {
                    if (data?.code === 200) {
                        handleCloseModal();
                        setRefresh(prev => !prev);
                    }
                },
            })
        );
    };

    const handleSubmitPartnerAccount = (e) => {
        e.preventDefault();
        const errors = validatePartnerForm();
        if (Object.keys(errors).length > 0) {
            setPartnerFormErrors(errors);
            return;
        }
        setPartnerFormErrors({});
        if (whitelabelData && whitelabelData._id) {
            
                partnerFormData.whitelabelID=whitelabelData._id
                partnerFormData.paramsType = REG_PARAMS

        }

        dispatch(
            signup({
                payload: partnerFormData,
                callback: (data) => {
                    if (data?.meta?.code === 200) {
                        handleCloseModal();
                        setRefresh(prev => !prev);
                    }
                },
            })
        );
    };
    let live_account_desc = "Quickly open a Live account with just a few clicks. Manage your trading experience with ease and transparency."
    let partner_account_desc = "Manage your partner accounts efficiently. Track balances, account numbers, and transactions at a glance."
    return (
        <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
                <ToAccountOpenCard
                    type="live_account"
                    onClick={() => handleSelectAccountType("live_account")} // card select
                    onOpenModal={() => handleOpenModal("live_account")} // open modal on button click
                    buttonSize="sm"
                    contentWidth="w-full"
                    icon={<FaWallet className="text-4xl" />}
                    title="Click Here To View Live Account"
                    buttontext="CLICK HERE TO OPEN LIVE ACCOUNT"
                    isSelected={selectedAccountType === "live_account"}
                    description={live_account_desc}
                />
                <ToAccountOpenCard
                    type="partner_account"
                    onClick={() => handleSelectAccountType("partner_account")} // card select
                    onOpenModal={() => handleOpenModal("partner_account")} // open modal on button click
                    buttonSize="sm"
                    contentWidth="w-full"
                    icon={<FaWallet className="text-4xl" />}
                    title="Click Here To View Partner Account"
                    buttontext="CLICK HERE TO OPEN PARTNER ACCOUNT"
                    isSelected={selectedAccountType === "partner_account"}
                    description={partner_account_desc}
                />
            </div>

            {/* Modal overlay */}
            {openModal && (
                <>
                    <div
                        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40"
                        onClick={handleCloseModal}
                    ></div>

                    <div className="fixed inset-0 flex items-center justify-center z-50 px-4">
                        <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative">

                            <button
                                onClick={handleCloseModal}
                                className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-2xl font-bold"
                                aria-label="Close modal"
                            >
                                &times;
                            </button>

                            {openModal === "live_account" && (
                                <>
                                    <h2 className="text-xl font-semibold text-center mb-6">Open Live Account</h2>
                                    <form className="space-y-4" onSubmit={handleSubmitLiveAccount}>
                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={liveAccountFormData.email}
                                                readOnly
                                                className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                            />
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">First Name</label>
                                                <input
                                                    type="text"
                                                    name="Fname"
                                                    value={liveAccountFormData.Fname}
                                                    readOnly
                                                    className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                                />
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Last Name</label>
                                                <input
                                                    type="text"
                                                    name="Lname"
                                                    value={liveAccountFormData.Lname}
                                                    readOnly
                                                    className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Password</label>
                                                <PasswordInput
                                                    className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                                    name="Password"
                                                    value={liveAccountFormData.Password}
                                                    onChange={handleLiveAccountChange}
                                                />
                                                {liveAccountFormErrors.Password && (
                                                    <Text fontSize="xs" color="red.500">{liveAccountFormErrors.Password}</Text>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Confirm Password</label>
                                                <PasswordInput
                                                    className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                                    name="cpassword"
                                                    value={liveAccountFormData.cpassword}
                                                    onChange={handleLiveAccountChange}
                                                />
                                                {liveAccountFormErrors.cpassword && (
                                                    <Text fontSize="xs" color="red.500">{liveAccountFormErrors.cpassword}</Text>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text-center mt-6">
                                            <CommonButton text="Submit" size="md" type="submit" />
                                        </div>
                                    </form>
                                </>
                            )}

                            {openModal === "partner_account" && (
                                <>
                                    <h2 className="text-xl font-semibold text-center mb-6">Open Partner Account</h2>
                                    <form className="space-y-4" onSubmit={handleSubmitPartnerAccount}>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">First Name</label>
                                                <input
                                                    type="text"
                                                    name="fname"
                                                    value={partnerFormData.fname}
                                                    onChange={handlePartnerFormChange}
                                                    className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                        ${partnerFormErrors.fname ? "border-red-500" : ""}
                                                    `}
                                                />
                                                {partnerFormErrors.fname && (
                                                    <Text fontSize="xs" color="red.500">{partnerFormErrors.fname}</Text>
                                                )}
                                            </div>
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Last Name</label>
                                                <input
                                                    type="text"
                                                    name="lname"
                                                    value={partnerFormData.lname}
                                                    onChange={handlePartnerFormChange}
                                                    className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                        ${partnerFormErrors.lname ? "border-red-500" : ""}
                                                    `}
                                                />
                                                {partnerFormErrors.lname && (
                                                    <Text fontSize="xs" color="red.500">{partnerFormErrors.lname}</Text>
                                                )}
                                            </div>
                                        </div>

                                        <div>
                                            <label className="block text-sm font-medium text-gray-700">Email</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={partnerFormData.email}
                                                onChange={handlePartnerFormChange}
                                                className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                    ${partnerFormErrors.email ? "border-red-500" : ""}
                                                `}
                                            />
                                            {partnerFormErrors.email && (
                                                <Text fontSize="xs" color="red.500">{partnerFormErrors.email}</Text>
                                            )}
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                                                <input
                                                    type="tel"
                                                    name="mobile"
                                                    value={partnerFormData.mobile}
                                                    onChange={handlePartnerFormChange}
                                                    className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                        ${partnerFormErrors.mobile ? "border-red-500" : ""}
                                                    `}
                                                />
                                                {partnerFormErrors.mobile && (
                                                    <Text fontSize="xs" color="red.500">{partnerFormErrors.mobile}</Text>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Promo Code (Optional)</label>
                                                <input
                                                    type="text"
                                                    name="promo"
                                                    value={partnerFormData.promo}
                                                    onChange={handlePartnerFormChange}
                                                    className="mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500"
                                                />
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Password</label>
                                                <PasswordInput
                                                    className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                        ${partnerFormErrors.password ? "border-red-500" : ""}
                                                    `}
                                                    name="password"
                                                    value={partnerFormData.password}
                                                    onChange={handlePartnerFormChange}
                                                />
                                                {partnerFormErrors.password && (
                                                    <Text fontSize="xs" color="red.500">{partnerFormErrors.password}</Text>
                                                )}
                                            </div>

                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">Confirm Password</label>
                                                <PasswordInput
                                                    className={`mt-1 w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500
                                                        ${partnerFormErrors.cpassword ? "border-red-500" : ""}
                                                    `}
                                                    name="cpassword"
                                                    value={partnerFormData.cpassword}
                                                    onChange={handlePartnerFormChange}
                                                />
                                                {partnerFormErrors.cpassword && (
                                                    <Text fontSize="xs" color="red.500">{partnerFormErrors.cpassword}</Text>
                                                )}
                                            </div>
                                        </div>

                                        <div className="text-center mt-6">
                                            <CommonButton text="Submit" size="md" type="submit" />
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
